import React from 'react';

import { List, FilterForm, Datagrid } from 'components/list';
import { TextInput, DateInput } from 'components/input';
import { TextField } from 'components/field';
import { EditButton } from 'components/button';

import {
  subsEditInquiryFrontPath,
  subsExtendInquiryFrontPath,
  subsShopRevokeFrontPath,
} from './urls';

export const SubsFilter = (props) => (
  <FilterForm name="sub_search" {...props}>
    <DateInput label="Expire From" source="start_time"/>
    <DateInput label="Expire To" source="end_time"/>
    <TextInput label="Owner Mobile" source="owner_mobile"/>
    <TextInput label="Shop ID" source="shop_id"/>
  </FilterForm>
);

const listActionOptions = {
  hasExport: true,
  exportFileName: "subscription_data.csv",
  exportHeaders: ["Shop ID", "Owner Mobile", "Owner Name", "Branch", "Branch Limit", "Expire"],
  exportSources: ["id", "owner_mobile", "owner_name", "active_count", "branch_count", "end_time"]
};

export const SubsList = (props) => (
  <List {...listActionOptions} {...props} filters={<SubsFilter />}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <TextField source="id" label="Shop ID"/>
      <TextField source="owner_mobile" label="Owner Mobile"/>
      <TextField source="owner_name" label="Owner Name"/>
      <TextField source="active_count" label="Branch"/>
      <TextField source="branch_count" label="Branch Limit"/>
      <TextField source="end_time" label="Expire"/>
      <EditButton label="Edit" linkTo={subsEditInquiryFrontPath}/>
      <EditButton label="Extend" linkTo={subsExtendInquiryFrontPath}/>
      <EditButton label="Revoke" linkTo={subsShopRevokeFrontPath}/>
    </Datagrid>
  </List>
);





// WEBPACK FOOTER //
// ./src/routes/subscription/SubsList.js